<template>
  <b-modal
    id="city-input-type-modal"
    class="custom-modal"
    centered
    title="Select Type"
    body-class="py-3"
    no-close-on-backdrop
    header-class="border-bottom-0"
    @shown="savedSelection = questionProperties.option.input_type; currentSelection = questionProperties.option.input_type;"
  >
    <b-form>
      <b-form-group label="City Input Type">
        <b-radio-group v-model="currentSelection" :options="cityInputTypes" class="d-flex"></b-radio-group>
      </b-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn
        variant="primary"
        class="ml-1"
        @click="saveCityType"
      >
        Save
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CityInputTypeModal",
  data() {
    return {
      cityInputTypes: [
        { value: "textbox", text: "Text Box" },
        { value: "MM", text: "Metro Manila Only" },
        { value: "ALL", text: "All Cities" }
      ],
      savedSelection: null,
      currentSelection: null
    }
  },
  computed: {
    ...mapGetters("surveys", ["questionProperties", "survey"])
  },
  methods: {
    saveCityType() {
      const question_properties = this.questionProperties;
      const page = this.survey.pages.find(page => page.uuid === question_properties.page_uuid);
      let question = null;
      if (question_properties.question_uuid) {
        question = page.questions.find(question => question.uuid === question_properties.question_uuid);
      } else {
        question = page.questions[question_properties.questionIndex];
      }
      question.contents.elements.find(element => element.type === "Address").options.find(option => option.type === "City").input_type = this.currentSelection;
      this.$root.$emit("bv::hide::modal", "city-input-type-modal");
    }
  }
}
</script>

<style lang="scss">
#city-input-type-modal {
  & > * {
    font-style: normal;
  }
  .modal-header .close {
    top: inherit;
  }
  .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    top: 4px !important;
  }
  .custom-control.custom-radio.custom-control-inline {
    flex-grow: 1;
  }
}
</style>